import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import languages from "../assets/languages";
import { usePublicUser } from "../context/PublicUserContext";

const logoMap: Record<string, string> = {};
try {
	// @ts-ignore
	const req = require.context("../assets/logos", true, /logo\.png$/);
	req.keys().forEach((key: string) => {
		const keySplit = key.split("/");

		logoMap[keySplit[1]] = req(key).default || req(key);
	});
} catch {
	/* empty */
}

export default function HeaderPublic() {
	const navigate = useNavigate();
	const { portal: userPortal } = usePublicUser();
	const intl = useIntl();

	let logoUrl: string | undefined = undefined;
	if (userPortal && logoMap[userPortal ?? ""]) {
		logoUrl = logoMap[userPortal ?? ""];
	}

	return (
		<header
			className="d-flex align-items-center justify-content-between px-3 py-2 container-fluid sticky-top"
			style={{
				minHeight: 90,
				boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
				backgroundImage: "linear-gradient(to right,#8e9eab,#eef2f3)",
				borderBottomWidth: 10,
				borderBottomColor: "#bc231e",
				borderBottomStyle: "solid",
			}}
		>
			<div className="container">
				<div className="container col-md-7 col-12">
					<div className="d-flex mx-auto mx-md-0 justify-content-between">
						{logoUrl ? (
							<img
								src={logoUrl}
								alt="Logo"
								style={{ height: 32, width: "auto", objectFit: "contain" }}
								className="me-2"
								onClick={() => navigate(`/${userPortal}`)}
							/>
						) : null}
						<div className="dropdown ms-2">
							<button
								className="btn btn-light  dropdown-toggle d-flex align-items-center px-2 py-1"
								type="button"
								id="languageDropdown"
								data-bs-toggle="dropdown"
								aria-expanded="false"
								style={{ minWidth: 44, fontSize: 18 }}
							>
								<span className="me-1">
									{languages.find((l) => l.Code.startsWith(intl.locale))?.Icon || "🌐"}
								</span>
							</button>
							<ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
								{languages.map((lang) => (
									<li key={lang.LanguageId}>
										<button
											className={`dropdown-item d-flex align-items-center${lang.Code.startsWith(intl.locale) ? " fw-bold bg-light" : ""}`}
											style={{ fontSize: 15 }}
											onClick={() => navigate(`/${userPortal}/${lang.Code}`, { replace: true })}
											aria-current={lang.Code.startsWith(intl.locale) ? "true" : undefined}
										>
											<span className="me-2" style={{ fontSize: 18 }}>
												{lang.Icon}
											</span>
											{lang.Name}
										</button>
									</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
}
